import { render, staticRenderFns } from "./IconQuestion.vue?vue&type=template&id=607ca9f6&scoped=true"
import script from "./IconQuestion.vue?vue&type=script&lang=js"
export * from "./IconQuestion.vue?vue&type=script&lang=js"
import style0 from "./IconQuestion.vue?vue&type=style&index=0&id=607ca9f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607ca9f6",
  null
  
)

export default component.exports